/* 🤖 this file was generated by script */
export const wsolidiconBell02 = {
  name: 'bell_02',
  data: `<svg viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M9 21a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1M7.05 3.05A7 7 0 0 1 19 8c0 2.91.73 4.84 1.5 6.08l.01.02q.54.86.83 1.35a6 6 0 0 1 .34.72q.06.14.06.45c-.02.14-.04.37-.18.61-.13.25-.32.4-.43.47a1.4 1.4 0 0 1-.63.25l-.49.04-1.37.01H5.36L4 17.99l-.49-.04a1.4 1.4 0 0 1-1.09-2.03l.25-.47q.29-.5.83-1.35l.01-.02C4.27 12.84 5 10.9 5 8a7 7 0 0 1 2.05-4.95" clip-rule="evenodd"/></svg>`,
  iconStyle: 'solid',
};
